<template>
  <div>
    <div v-if="compForComments.comments.length">
      <h3>Comments</h3>
      <ul>
        <li v-for="comment in compForComments.comments">{{comment.text}} by {{comment.commentator.name}}</li>
      </ul>
    </div>
    <div v-else>
      There are no comments on this report component yet. Be the first by entering a comment below.
    </div>

    <el-input v-model="newCommentText"></el-input>
    <el-button @click="saveComment">Save</el-button>
    <p>Note that you are commenting on this chart in this report, regardless of filter value.</p>
    <p>{{info}}</p>
  </div>
</template>

<script>
export default {
  name: "CommentThread",
  props: ['compForComments'],
  data() {
    return {
      newCommentText: '',
      savedState: 'new',
    }
  },
  computed: {
    info: function () {
      if (this.savedState==='saved') {
        return 'Successfully saved, and the comment will appear when people reload the report. This feature is still being developed. You will need to refresh this page to see the comment reflected in the chart. '
      } else if (this.newCommentText) {
        return 'Hit save to save your comment.'
      } else {
        return ''
      }
    }
  },
  watch: {
    newComment: function () {
      if (this.savedState === 'saved') {
        this.savedState = 'new'
      }
    }
  },
  methods: {
    saveComment() {
      axios.post('/api/comments/' + this.compForComments.report.id, {
        commentText: this.newCommentText,
        component: this.compForComments
      }).then(response => {
        // success
        this.savedState = 'saved'
        this.compForComments.comments.push(
            {
              text:this.newCommentText,
              commentator: {
                name:'You (since last page refresh)'
              }
            }
        )
      }).catch(error => {
        console.log(error)
      })
    },
  }
}
</script>

<style scoped>

</style>